﻿import * as $ from 'jquery';
import { Loader } from './loader';
import { OrganizationEditWidget } from './organizationEdit';
import DataTable from 'datatables.net';

export class OrganizationListWidget {
    private element: HTMLElement;
    private loader: Loader;
    private tableElement: HTMLTableElement;
    private dataTable: any;

    constructor(element: HTMLElement) {
        this.element = element;
    }

    public init(): void {
        this.loader = new Loader();
        this.tableElement = this.element.querySelector('table')!;
        //this.initializeDataTable();
        this.setupEventListeners();
    }

    //private initializeDataTable(): void {
    //    this.dataTable = $(this.tableElement).DataTable({
    //        language: {
    //            url: '//cdn.datatables.net/plug-ins/1.13.6/i18n/sl.json'
    //        }
    //    });
    //}

    private setupEventListeners(): void {
        // Handle add organization button click
        //$(this.element).on('click', '.btn-add-organization', (e) => {
        //    e.preventDefault();
        //    this.loadAddOrganizationForm();
        //});

        // Handle details button click
        //$(this.element).on('click', '.btn-details', (e) => {
        //    e.preventDefault();
        //    const url = $(e.currentTarget).attr('href')!;
        //    this.loadOrganizationDetails(url);
        //});
    }

    private loadAddOrganizationForm(): void {
        this.loader.show();
        $.get('/organizacije/dodaj')
            .done((data) => {
                this.showModal('Dodaj organizacijo', data);
            })
            .fail((error) => {
                console.error('Error loading add form:', error);
                this.showError('Napaka pri nalaganju obrazca za dodajanje organizacije.');
            })
            .always(() => {
                this.loader.hide();
            });
    }

    private loadOrganizationDetails(url: string): void {
        this.loader.show();
        $.get(url)
            .done((data) => {
                this.showModal('Podrobnosti organizacije', data);
            })
            .fail((error) => {
                console.error('Error loading details:', error);
                this.showError('Napaka pri nalaganju podrobnosti organizacije.');
            })
            .always(() => {
                this.loader.hide();
            });
    }

    private showModal(title: string, content: string): void {
        // You can use Bootstrap modal or implement your own
        const modal = $(`
            <div class="modal fade" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">${title}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            ${content}
                        </div>
                    </div>
                </div>
            </div>
        `) as any;

        modal.modal('show');
        modal.on('hidden.bs.modal', () => {
            modal.remove();
        });

        // Initialize any edit widgets if present
        const editWidgetElement = modal.find('.organization-edit')[0];
        if (editWidgetElement) {
            new OrganizationEditWidget(editWidgetElement).init();
        }
    }

    private showError(message: string): void {
        // Implement error display logic
        alert(message); // Replace with a proper notification system
    }
}